<div class="source-form-wrapper">
  <form id="form" class="details-form" [formGroup]="form" novalidate>
    <div class="source-form-data-wrapper">
      <h2>{{ "global-forms.dataSource.title" | translate }}</h2>

      <div class="source-form-fields">
        <ng-template #slugTemplate>
          <div class="form-row" *ngIf="isSuperAdmin">
            <mat-form-field>
              <input
                [maxLength]="identifierMaxLength"
                matInput
                formControlName="Slug"
                name="Slug"
                required
                placeholder="{{ 'sources.fields-placeholders.Slug' | translate }}"
              />
              <mat-error *ngIf="form.get('Slug').errors && form.get('Slug').errors.pattern">
                {{ "validation.is_not_valid" | translate: { name: ("sources.fields-placeholders.Slug" | translate) } }}
              </mat-error>
              <mat-error *ngIf="isRequiredError('Slug')">
                {{ "validation.required" | translate: { name: ("sources.fields-placeholders.Slug" | translate) } }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-template>

        <mee-permissions-fields-sa-ca
          *ngIf="isSuperAdmin || isCompanyAdmin; else permissionsForTeamAdmin"
          [selectedItem]="null"
          [isUpdateMode]="false"
          (changePermissionsData)="onChangePermissionsData($event)"
          [slugFieldTemplateRef]="slugTemplate"
          [descriptionFieldTemplateRef]="descriptionTemplate"
        ></mee-permissions-fields-sa-ca>

        <ng-template #permissionsForTeamAdmin>
          <mee-permissions-fields-ta
            [selectedItem]="null"
            [isUpdateMode]="false"
            (changePermissionsData)="onChangePermissionsData($event)"
            [slugFieldTemplateRef]="slugTemplate"
            [descriptionFieldTemplateRef]="descriptionTemplate"
          ></mee-permissions-fields-ta>
        </ng-template>

        <ng-template #descriptionTemplate>
          <div class="form-row name-wrapper">
            <mat-form-field>
              <input
                matInput
                formControlName="Description"
                name="Description"
                placeholder="{{ 'sources.fields-placeholders.Description' | translate }}"
              />
              <span matSuffix>{{ form.get("Slug").value }}</span>
            </mat-form-field>
          </div>
        </ng-template>

        <div class="category-autocomplete">
          <mee-category-autocomplete
            [editModeCategoryName]="editModeCategoryName"
            (categoryCreateDataChanged)="categoryCreateDataChanged($event)"
            (categoryNameChanged)="onCategoryNameChanged($event)"
          ></mee-category-autocomplete>
        </div>
      </div>
    </div>

    <div class="type-wrapper">
      <h2>{{ "global-forms.dataSource.Type" | translate }}</h2>

      <div class="type-section" [ngClass]=" { 'with-category' : isCompanyAdmin }">
        <div class="form-row">
          <mat-form-field>
            <input
              meeRemoveAutofill
              formControlName="Type"
              type="text"
              [placeholder]="'sources.fields-placeholders.Type' | translate"
              required
              matInput
              [matAutocomplete]="auto"
              autocomplete="off"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayTypeProperty.bind(this)"
              (optionSelected)="setTypeValue($event)"
            >
              <mat-option *ngFor="let type of typesFiltered | async" [value]="type.type">
                {{ type.title }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isRequiredError('Type')"
              >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Type" | translate) } }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-row" *ngIf="isSetTemplateAvailable">
          <mat-form-field>
            <mat-label>{{ "sources.configuration.setTemplate.title" | translate }}</mat-label>
            <mat-select formControlName="TemplateId">
              <mat-option *ngIf="templatesList.length === 0">None</mat-option>
              <mat-option *ngFor="let template of templatesList" [value]="template.Id">
                {{ template.Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-row" *ngIf="isArcGisType() || isArcGisSceneType()">
          <mat-form-field>
            <mat-select
              (selectionChange)="onSecurityTypeSelect($event)"
              formControlName="Security"
              [required]="isArcGisType() || isArcGisSceneType()"
              placeholder="{{ 'sources.fields-placeholders.Security' | translate }}"
            >
              <mat-option *ngFor="let type of arcGisSecurityTypes" [value]="type.id">
                {{ type.translationKey | translate }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="isRequiredError('Security')"
              >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Security" | translate) } }}
            </mat-error>
          </mat-form-field>
        </div>

        <ng-container *ngIf="isPix4dType()">
          <div class="form-row">
            <mat-form-field>
              <input
                matInput
                type="text"
                formControlName="ClientId"
                required
                placeholder="{{ 'sources.fields-placeholders.ClientId' | translate }}"
              />
            </mat-form-field>

            <mat-form-field>
              <input
                matInput
                formControlName="ClientSecret"
                required
                type="password"
                placeholder="{{ 'sources.fields-placeholders.ClientSecret' | translate }}"
              />
            </mat-form-field>
          </div>
        </ng-container>

        <!-- For source Type: WFS-->

        <div class="form-row" *ngIf="isWFSType()">
          <mat-form-field>
            <mat-select
              formControlName="Security"
              [required]="isWFSType()"
              placeholder="{{ 'sources.fields-placeholders.Security' | translate }}"
            >
              <mat-option *ngFor="let type of wfsSecurityTypes" [value]="type.id">
                {{ type.translationKey | translate }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="isRequiredError('Security')"
              >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Security" | translate) } }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="file-upload-field" *ngIf="isShowFileLoader">
          <div class="optional-inputs upload-wrapper">
            <div class="upload-button-wrapper">
              <mee-file-upload-button
                [existingFileUrl]="dataSourceFile.FileUrl"
                [mediaType]="mediaType"
                (uploaded)="uploadFile($event)"
                (removeRequiredFile)="onRemoveRequiredFile('File')"
              >
                <div data-requirements-tooltip>
                  <button  class="tooltip" *ngIf="isShapefileType()" [cdkMenuTriggerFor]="menuShapeFile">
                    <span class="label">{{ "sources.Requirements" | translate }}</span>
                    <mat-icon>chevron_right</mat-icon>
                  </button>

                  <ng-template #menuShapeFile>
                    <div class="tooltip-content" cdkMenu>
                      <ul class="instruction-list">
                        <li>{{ "sources.shapefileInstruction.Include" | translate }}</li>
                        <li>{{ "sources.shapefileInstruction.Place" | translate }}</li>
                        <li>{{ "sources.shapefileInstruction.Compress" | translate }}</li>
                        <li>{{ "sources.shapefileInstruction.Upload" | translate }}</li>
                      </ul>
                    </div>
                  </ng-template>
                </div>
                <small data-required-indicator class="required-ind" *ngIf="isRequiredIndicatorVisible">*</small>
              </mee-file-upload-button>
            </div>

            <p class="option">{{ "commonPhrases.Or" | translate }}</p>

            <mat-form-field class="cloud-link">
              <input [formControl]="cloudLinkControl" matInput type="text" placeholder="{{ 'PointClouds.LoadFromCloud' | translate }}" />
            </mat-form-field>
          </div>
        </div>

        <!-- For Source Type: ArcGis -->
        <div class="optional-inputs" *ngIf="isArcGisType() || isArcGisSceneType() || isArcGisNtlm()">
          <mat-slide-toggle formControlName="IsArcGisOnline" name="IsArcGisOnline" color="primary" (change)="clearSelection()">
            {{ "sources.fields-placeholders.IsArcGisOnline" | translate }}
          </mat-slide-toggle>
        </div>

        <!-- For Source Type: ArcGis -->
        <div class="optional-inputs" [class.hidden]="!isArcGisType()">
          <mat-slide-toggle formControlName="IsRealTime" name="IsRealTime" color="primary" (change)="clearSelection()">
            {{ "sources.fields-placeholders.IsRealTime" | translate }}
          </mat-slide-toggle>
        </div>

        <div class="form-row" [class.hidden]="!isArcGisType()">
          <mat-form-field>
            <input
              matInput
              formControlName="FeatureServiceUrl"
              name="FeatureServiceUrl"
              title="{{ form.get('FeatureServiceUrl').value }}"
              placeholder="{{ 'sources.fields-placeholders.FeatureServiceUrl' | translate }}"
              [required]="isArcGisType()"
            />
            <mat-error *ngIf="isRequiredError('FeatureServiceUrl')"
              >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.FeatureServiceUrl" | translate) } }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-row" *ngIf="isArcGisSceneType()">
          <mat-form-field>
            <input
              matInput
              formControlName="SceneServiceUrl"
              name="SceneServiceUrl"
              title="{{ form.get('SceneServiceUrl').value }}"
              placeholder="{{ 'sources.fields-placeholders.SceneServiceUrl' | translate }}"
              [required]="isArcGisSceneType()"
            />
            <mat-error *ngIf="isRequiredError('SceneServiceUrl')"
              >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.SceneServiceUrl" | translate) } }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-row" *ngIf="isWFSType()">
          <mat-form-field>
            <input
              matInput
              formControlName="BaseUrl"
              name="BaseUrl"
              title="{{ form.get('BaseUrl').value }}"
              placeholder="{{ 'sources.fields-placeholders.BaseUrl' | translate }}"
              [required]="isWFSType()"
            />
            <mat-error *ngIf="isRequiredError('BaseUrl')"
              >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.BaseUrl" | translate) } }}
            </mat-error>
          </mat-form-field>
        </div>

        <!--For WFS type password-->

        <div class="form-row" *ngIf="isWFSPassword()">
          <mat-form-field>
            <input
              matInput
              [type]="'text'"
              [required]="isWFSPassword()"
              formControlName="Username"
              name="Username"
              autocomplete="off"
              placeholder="{{ 'sources.fields-placeholders.Username' | translate }}"
            />
            <mat-error *ngIf="isRequiredError('Username')"
              >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Username" | translate) } }}
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <input
              type="password"
              matInput
              [required]="isWFSPassword()"
              formControlName="Password"
              autocomplete="off"
              name="Password"
              meeRemoveAutofill
              placeholder="{{ 'sources.fields-placeholders.Password' | translate }}"
            />
            <mat-error *ngIf="isRequiredError('Password')"
              >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Password" | translate) } }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- For Type: Password -->
        <div class="form-row" [class.hidden]="!isArcGisPassword()">
          <mat-form-field>
            <input
              matInput
              formControlName="AuthenticationUrl"
              name="AuthenticationUrl"
              placeholder="{{ 'sources.fields-placeholders.AuthenticationUrl' | translate }}"
              [required]="isArcGisPassword()"
            />
            <mat-error *ngIf="isRequiredError('AuthenticationUrl')"
              >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.AuthenticationUrl" | translate) } }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-row" [class.hidden]="(!isArcGisPassword() || !form.get('AuthenticationUrl').value) && !isArcGisNtlm()">
          <mat-form-field>
            <input
              matInput
              [type]="'text'"
              [required]="isArcGisNtlm() || (isArcGisPassword() && form.get('AuthenticationUrl').value != '')"
              formControlName="Username"
              name="Username"
              autocomplete="off"
              placeholder="{{ 'sources.fields-placeholders.Username' | translate }}"
            />
            <mat-error *ngIf="isRequiredError('Username')">
              {{ "validation.required" | translate: { name: ("sources.fields-placeholders.Username" | translate) } }}
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <input
              type="password"
              autocomplete="off"
              matInput
              [required]="isArcGisNtlm() || isArcGisPassword()"
              formControlName="Password"
              meeRemoveAutofill
              name="Password"
              placeholder="{{ 'sources.fields-placeholders.Password' | translate }}"
            />
            <mat-error *ngIf="isRequiredError('Password')"
              >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Password" | translate) } }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- For Type: Token -->

        <div class="form-row" [class.hidden]="!isArcGisToken()">
          <mat-form-field>
            <input
              type="password"
              matInput
              formControlName="Token"
              autocomplete="off"
              name="Token"
              meeRemoveAutofill
              placeholder="{{ 'sources.details.Token' | translate }}"
              [required]="isArcGisToken()"
            />
            <mat-error *ngIf="isRequiredError('Token')"
              >{{ "validation.required" | translate: { name: ("sources.details.Token" | translate) } }}
            </mat-error>
          </mat-form-field>
        </div>

        <!--ArcGis Portal-->

        <div *ngIf="!isArcGisSceneType() && (isArcGisPassword() || isArcGisToken())">
          <div class="form-row">
            <mat-form-field>
              <input
                matInput
                formControlName="PortalUrl"
                name="PortalUrl"
                placeholder="{{ 'sources.fields-placeholders.PortalUrl' | translate }}"
              />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field>
              <input
                matInput
                formControlName="PortalItemId"
                name="PortalItemId"
                placeholder="{{ 'sources.fields-placeholders.PortalItemID' | translate }}"
              />
            </mat-form-field>
          </div>
        </div>

        <!--ArcGis end portal-->

        <div class="iModel-inputs" *ngIf="isIModelType() || isIModelGisType()">
          <div class="form-row">
            <mat-form-field>
              <input
                matInput
                formControlName="ProjectName"
                name="ProjectName"
                [required]="isIModelType() || isIModelGisType()"
                placeholder="{{ 'sources.fields-placeholders.ProjectName' | translate }}"
              />
              <mat-error *ngIf="form.get('ProjectName').errors && form.get('ProjectName').errors.pattern">
                {{ "validation.is_not_valid" | translate: { name: ("sources.fields-placeholders.ProjectName" | translate) } }}
              </mat-error>
              <mat-error *ngIf="isRequiredError('ProjectName')">
                {{ "validation.required" | translate: { name: ("sources.fields-placeholders.ProjectName" | translate) } }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field>
              <input
                matInput
                formControlName="ModelName"
                name="ModelName"
                [required]="isIModelType() || isIModelGisType()"
                placeholder="{{ 'sources.fields-placeholders.ModelName' | translate }}"
              />
              <mat-error *ngIf="form.get('ModelName').errors && form.get('ModelName').errors.pattern">
                {{ "validation.is_not_valid" | translate: { name: ("sources.fields-placeholders.ModelName" | translate) } }}
              </mat-error>
              <mat-error *ngIf="isRequiredError('ModelName')">
                {{ "validation.required" | translate: { name: ("sources.fields-placeholders.ModelName" | translate) } }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <ng-container *ngIf="isSimpleModelType()">
          <div class="simple-model-source file-load_instruction">
            <div class="file-load">
              <mee-simple-model-file-loader
                [existingFiles]="[]"
                (newFilesAdded)="onSimpleModelNewFilesAdded($event)"
              >
                <small data-required-indicator class="required-ind with-margin" *ngIf="form.get('NewFiles').value.length === 0">*</small>
                <div data-requirements-tooltip>
                  <button class="tooltip" [cdkMenuTriggerFor]="menuSimpleModel">
                    <span class="label">{{ "sources.Requirements" | translate }}</span>
                    <mat-icon>chevron_right</mat-icon>
                  </button>

                  <ng-template #menuSimpleModel>
                    <div class="tooltip-content" cdkMenu>
                      <ul class="instruction-list">
                        <li>{{ "sources.SimpleModelInstruction.SupportedTypes" | translate }}</li>
                        <li>{{ "sources.SimpleModelInstruction.ZipFile" | translate }}</li>
                        <li>{{ "sources.SimpleModelInstruction.UseSelectFile" | translate }}</li>
                      </ul>
                    </div>
                  </ng-template>
                </div>
              </mee-simple-model-file-loader>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </form>

  <div class="action-buttons with-padding">
    <button mat-ripple class="cancel-button" (click)="cancel()" type="button">{{ "global-forms.cancel" | translate }}</button>
    <button (click)="onSubmit(form)" mat-ripple [disabled]="form.invalid || !isIdentifier || isPermissionsLimit" [ngClass]="{ disabled: form.invalid || !isIdentifier || isPermissionsLimit }" class="add-button" type="submit">
      {{ "global-forms.add" | translate }}
    </button>
  </div>
</div>
